import paddleNav from './paddleNav';
export default paddleNav;



// WEBPACK FOOTER //
// ./src/components/paddleNav/index.js